import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IPopupInformation } from '../interfaces/IPopupInformation';

@Component({
  selector: 'app-popup-information-dialog',
  templateUrl: './popup-information-dialog.component.html',
  styleUrls: ['./popup-information-dialog.component.scss'],
})
export class PopupInformationDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public popupInformation: IPopupInformation
  ) {}

  ngOnInit(): void {}
}
